/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  CpdLiStyleTag,
  CpdPstyleTag,
  CpdWrapperStyle,
  CpdsCaptionbSVG,
  CpdsCaptionsStyleTag,
  CpdsUlStyleTag,
} from './styles/cpds-captions-style';
import { CpdsCaptionsProps, LinkWrapperProps } from './typings';
import { Cpds } from '@Cpds.Ui';
import { checkValue } from '../../helper';
import {themeToken} from "../utils/cpds-utils";
import { useTheme } from 'styled-components'
import { themeStyleClass } from '../utils/cpds-utils';

const CpdsCaptions: React.FC<CpdsCaptionsProps> = ( props) => {  

  const theme = useTheme();
  const { styles : {cpds} } = theme;

  const {
    domRef,
    exClasses: exClassesPTag,
    styleOverrides,
    children,
    gapBetween,
    fontColor,
    fontSize,
    fontWeight,
    lineHeight,
    iconTopMargin,
    hoverEffect = false,
    changeOrder = false,
    link,
    iconName,
    iconSize='medium',
    customSize,
    themeColorMode,
    themeTypography,
    iconColor
  } = props;

  const { token } = themeToken(cpds, cpds?.themeColorMode, themeColorMode);
  const classNamePTag = themeStyleClass('cpds-captions', themeTypography, exClassesPTag);

  /* Important : By default html tag is <div></div> 
  but you can change that into suitable html element base on your requirements*/
  //CpdWrapperStyle, CpdsUlStyleTag, CpdLiStyleTag, CpdPstyleTag   {/* <li><p>{children}</p></li> */}
 const WrapperElement: React.FC<LinkWrapperProps> = ({ link, children }) => {
    return checkValue(link?.url) ? (
      <a href={link?.url} target={link?.target} className={link?.exClass}>
        {children}{' '}
      </a>
    ) : (
      children
    );
  };
 
  
  return (
    <CpdWrapperStyle  ref={domRef} styleOverrides={styleOverrides}>
      <CpdsUlStyleTag gapBetween={gapBetween} changeOrder={changeOrder}>
       
       {iconName && (<CpdsCaptionbSVG iconTopMargin={iconTopMargin}>
          <Cpds.Icon id='key-1' name={iconName} color={iconColor || token?.caption_icon_color}  size={iconSize} customSize={customSize}/>
       </CpdsCaptionbSVG>)}
       
        <CpdLiStyleTag hoverEffect={hoverEffect}>
          <WrapperElement link={link}>
            <CpdPstyleTag className={classNamePTag} fontColor={fontColor} fontSize={fontSize} fontWeight={fontWeight} lineHeight={lineHeight} themeColorMode={themeColorMode}>{children}</CpdPstyleTag>
          </WrapperElement>
        </CpdLiStyleTag>
      </CpdsUlStyleTag>
    </CpdWrapperStyle>
  );
};

export default CpdsCaptions;
